module.exports = __webpack_public_path__ + "img/h数据资源.99be6fbd.svg";